import React, {Fragment, useEffect} from 'react';
import '@components/footer/footer.scss';
import {translate} from '@src/helpers';
import {useSelector} from 'react-redux';
import {Translations} from '@constants/translate';
import ResizeComponent from "@components/footer/ResizeComponent";
import {socialIcon} from "@components/footer/helper";
import {getBasicConfig} from '@api/Common';

const Footer = ({footer}: any) => {
  const langData = useSelector((state: any) => state.currentLanguage) as any;
  const brandSocials = useSelector((state: any) => state.brandSocials) as any;
  const footerSticky = useSelector((state: any) => state.footerSticky) as any;
  const year = (new Date()).getFullYear();

  const addGoogleScript = (googleTagManagerId: string, googleAnalyticId: string) => {
    const script = document.createElement('script');
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${googleTagManagerId}');`;
    document.head.appendChild(script);

    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${googleTagManagerId}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.prepend(noscript);

    const googleAnalyticScriptSrc = document.createElement('script');
    googleAnalyticScriptSrc.src = `https://www.googletagmanager.com/gtag/js?id=${googleAnalyticId}`;
    googleAnalyticScriptSrc.async = true;
    document.body.appendChild(googleAnalyticScriptSrc);

    const googleAnalyticScript = document.createElement('script');
    googleAnalyticScript.innerHTML = `window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${googleAnalyticId}');`;
    document.body.appendChild(googleAnalyticScript);
  }

  useEffect(() => {
    const getConfig = async() => {
      const {data} = await getBasicConfig();
      const {google_tag_manager_id, google_analytic_id} = data;
      if (google_tag_manager_id && google_analytic_id) {
        addGoogleScript(google_tag_manager_id, google_analytic_id);
      }
    };
    getConfig().then();
  }, []);

  return (
    <Fragment>

      <footer className="footer">
        <div className="container">
          {!footer.logo && <div
              className="default-footer">{translate(langData.localize, Translations["FIP.COMMON.ALL_RIGHTS_RESERVED"])} {year}</div>}
          {
            footer.logo &&
              <div className="brand-footer">
                  <a href={footer.url} className="brand-footer_logo"><img src={footer.logo} alt=""/></a>
                  <div className="brand-footer_socials">
                    {
                      footer.socials && footer.socials.length > 0 && footer.socials.map((social: any, idx: number) =>
                        <a href={social.url} key={`socical-${idx}`} target={"_blank"} rel="noopener noreferrer">
                          <img src={socialIcon(social.type)} alt=""
                               style={{width: "24px", height: "auto"}}
                          />
                        </a>
                      )
                    }
                  </div>
              </div>
          }
        </div>
      </footer>

      <ResizeComponent/>

    </Fragment>
  );
}

export default Footer;